export default function propsProvider(props) {
    /*
      - To only list utilized props
      - Wrapping utilized props on each view
  */
    const {
        intl,
        columns,
        keyword,
        setKeyword,
        handleEditClick,
        handleDeleteClick,
        handleAddClick,
        openDialog,
        handleCloseDialog,
        handleSubmit,
        initialValues,
        onChangeImage,
        articleData,
        articleAdminList,
        isAdd,
        pageSize,
        setPageSize,
        tableData,
        currentPage,
        setCurrentPage,
        handleChangeCurrentPage,
    } = props;
    return {
        intl,
        columns,
        keyword,
        setKeyword,
        handleEditClick,
        handleDeleteClick,
        handleAddClick,
        openDialog,
        handleCloseDialog,
        handleSubmit,
        initialValues,
        onChangeImage,
        articleData,
        articleAdminList,
        isAdd,
        pageSize,
        setPageSize,
        tableData,
        currentPage,
        setCurrentPage,
        handleChangeCurrentPage,
    };
}
